// src/components/Banner.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  Container,
  Grid,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

import { companyPhone, companyEmail } from "../../config/globalVariables";

const Banner = () => {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const handleLanguageChange = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Box
      sx={{
        backgroundColor: "primary.main",
        color: "primary.contrastText",
        px: {
          xs: 0,
          sm: 4,
          md: 6,
        },
        py: 0,
      }}
    >
      <Container sx={{ mx: 0 }} maxWidth="100">
        <Grid container alignItems="center" justifyContent="space-between">
          {/* Left Side (Phone and Email) */}
          <Grid item>
            <Typography
              variant="body2"
              sx={{
                fontSize: {
                  xs: "0.8rem",
                },
              }}
            >
              {companyPhone}&nbsp;&nbsp;|&nbsp;
              {companyEmail}
            </Typography>
          </Grid>

          {/* Right Side (Language Dropdown) */}
          <Grid item>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 90 }}>
              <Select
                labelId="language-select-label"
                value={i18n.language}
                onChange={handleLanguageChange}
                IconComponent={KeyboardArrowDownIcon}
                size="small"
                sx={{
                  color: "primary.contrastText",
                  fontSize: {
                    xs: "0.8rem",
                  },
                  padding: "4px 8px",
                  border: "none",
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                  },
                  "& .MuiSvgIcon-root": { fontSize: "16px", color: "inherit" },
                }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="lv">Latviešu</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Banner;
